import { XCircleIcon } from "@heroicons/react/16/solid";
import { METHOD_TYPE_TRANSLATIONS } from "@services/TranslateCsvHeaders";
import { TranslateErrorMessage } from "@services/ErrorHandling";

type FailedDepartmentsTableProps = {
  failedDepartments: [];
  handleDeleteDepartment: (index: number) => void;
};

export const FailedDepartmentsTable: React.FC<FailedDepartmentsTableProps> = ({
  failedDepartments,
  handleDeleteDepartment,
}) => {
  return (
    <div className="ml-2 mr-2 sm:ml-4 sm:mr-4">
      <div className="ml-2 mr-2 sm:ml-4 sm:mr-4">
        <table className="table-auto w-full border-collapse">
          <thead>
            <tr className="bg-gray-100 text-gray-600">
              <th className="border-b border-gray-300 p-3 text-left w-1/4">
                行
              </th>
              <th className="border-b border-gray-300 p-3 text-left w-1/4">
                コード
              </th>
              <th className="border-b border-gray-300 p-3 text-left w-1/3">
                エラー
              </th>
              <th className="border-b border-gray-300 p-3 text-left w-1/5">
                操作
              </th>
              <th className="border-b border-gray-300 p-3 text-center w-[100px] whitespace-nowrap">
                削除
              </th>
            </tr>
          </thead>
          <tbody>
            {failedDepartments?.map((department, index) => (
              <tr
                key={index}
                className="hover:bg-gray-50 transition-colors ease-in-out"
              >
                <td className="border-t border-gray-300 p-3">
                  {department.row || ""}
                </td>
                <td className="border-t border-gray-300 p-3">
                  {department.display_order || ""}
                </td>
                <td className="border-t border-gray-300 p-3">
                  {TranslateErrorMessage(department.error)}
                </td>
                <td className="border-t border-gray-300 p-3">
                  {METHOD_TYPE_TRANSLATIONS[department.method] || "未知の操作"}
                </td>
                <td className="border-t border-gray-300 p-3 text-center">
                  <button
                    className="text-red-600 hover:text-red-800 transition-colors ease-in-out"
                    onClick={() => handleDeleteDepartment(index)}
                    title="削除"
                  >
                    <XCircleIcon className="w-5 h-5 mx-auto" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
